import { Field, ErrorMessage, FieldProps } from 'formik';
import { AutoComplete as AntAutoComplete, Input, Flex } from 'antd';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import { AutoCompleteProps } from 'utils/globalTypes';

function AutoComplete(props: AutoCompleteProps) {
  const { label, name, showErrMsg = true, info, qaSelector, ...rest } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue } = form;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onChange = (value: string) => {
            setFieldValue(name, value);
          };
          return (
            <AntAutoComplete
              className='width100'
              value={field.value}
              {...rest}
              onChange={onChange}
            >
              <Input
                status={fieldStatus}
                name={field.name}
                onBlur={field.onBlur}
                data-qa-selector={qaSelector}
              />
            </AntAutoComplete>
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => <TextError msg={msg} qaSelector={`${qaSelector}-error`} />}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default AutoComplete;
